import { useTranslation } from 'react-i18next';
import BillingTimeline from "./BillingTimeline";

const ClientBillingSummary = () => {
  const { t } = useTranslation();
  const billing = {
    total: 5000,
    paid: 2500,
    pending: 2500,
    retainer: 2500,
    interval: "1.5 weeks",
    nextDue: "2025-07-02",
    status: "Partially Paid",
  };

  const handlePayNow = async () => {
    try {
      const res = await fetch("/api/stripe/create-checkout-session", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          amount: billing.pending, 
          clientId: 455,
          caseId: "47172c2a010bfc52489d68f9cd41c09faeb557f6c0edde72",
        }),
      });

      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        alert(t("Unable to create checkout session."));
      }
    } catch (error) {
      console.error("Stripe Checkout Error:", error);
      alert(t("Something went wrong."));
    }
  };

  return (
    <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-sm p-6">
      <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        {t('Client Billing Summary')}
      </h2>

      <dl className="grid grid-cols-2 gap-x-4 gap-y-3 text-sm text-gray-700 dark:text-gray-300">
        <div>
          <dt className="font-medium">{t('Total Agreed')}</dt>
          <dd>${billing.total.toLocaleString()}</dd>
        </div>
        <div>
          <dt className="font-medium">{t('Paid')}</dt>
          <dd>${billing.paid.toLocaleString()}</dd>
        </div>
        <div>
          <dt className="font-medium">{t('Pending')}</dt>
          <dd>${billing.pending.toLocaleString()}</dd>
        </div>
        <div>
          <dt className="font-medium">{t('Next Due')}</dt>
          <dd>{billing.nextDue}</dd>
        </div>
        <div>
          <dt className="font-medium">{t('Interval')}</dt>
          <dd>{billing.interval}</dd>
        </div>
        <div>
          <dt className="font-medium">{t('Status')}</dt>
          <dd>
            <span
              className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${
                billing.status === "Partially Paid"
                  ? "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300"
                  : billing.status === "Fully Paid"
                  ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300"
                  : "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300"
              }`}
            >
              {t(billing.status)}
            </span>
          </dd>
        </div>
      </dl>

      <div className="mt-6">
        <BillingTimeline paid={billing.paid} total={billing.total} />
      </div>

      {billing.pending > 0 && (
        <div className="mt-6">
          <button
            onClick={handlePayNow}
            className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md transition"
          >
            {t('Pay Now')}
          </button>
        </div>
      )}
    </div>
  );
};

export default ClientBillingSummary;
